import BaseObjectStore from './base/base-object-store.js'

// TENANT-5581 (QA C2): counts the loading indicators currently on screen, so the
// consent gate can tell whether the page underneath is already telling the user
// it is not ready.
//
// TENANT-5559 made the consent-gate scrim paint nothing, on the premise that
// every route running `useVerificationGuard()` renders a loading state of its
// own. That premise was wrong: /referral-center and /property/new paint a
// finished-looking layout with empty fields and no cue at all while the gate is
// still blocking, and /account is only spared because its window is too short to
// see. Restoring the scrim's own spinner unconditionally would bring back the
// double loader on the routes that DO have one (/properties, /stays, /bookings).
//
// So the scrim asks instead of assuming. `SpinnerAtomComponent` claims while it
// is mounted; the scrim shows its own tint and spinner only when nothing else
// does. A claim is a count, not a flag, because several spinners can be on
// screen at once and the last one to unmount is what matters.
class PageLoadingAffordanceStore extends BaseObjectStore {
    constructor () {
        super({
            claims: 0,
        })
    }

    // Returns a release function, so a caller cannot release a claim it never
    // made and an unmount cannot double-release.
    claim () {
        this.setState({
            claims: this.get('claims') + 1,
        })
        let released = false
        return () => {
            if (released) return
            released = true
            this.setState({
                claims: Math.max(0, this.get('claims') - 1),
            })
        }
    }

    isClaimed () {
        return this.get('claims') > 0
    }
}

const pageLoadingAffordanceStore = new PageLoadingAffordanceStore()
export default pageLoadingAffordanceStore
